import KapacitorPage from './containers/KapacitorPage'
import KapacitorRulePage from './containers/KapacitorRulePage'
import KapacitorRulesPage from './containers/KapacitorRulesPage'
import TickscriptPage from './containers/TickscriptPage'
import TickscriptsPage from './containers/TickscriptsPage'
import FluxTaskPage from './containers/FluxTaskPage'
import FluxTasksPage from './containers/FluxTasksPage'

export {
  KapacitorPage,
  KapacitorRulePage,
  KapacitorRulesPage,
  TickscriptPage,
  TickscriptsPage,
  FluxTaskPage,
  FluxTasksPage,
}
